// The name a group shows. A group named only by a number ("5", "12", "4-2")
// is the same in every building, so its category's name follows it:
// "5 · Hage 1". Other names stay as they are. The mobile app applies the same
// rule (its lib/groupName.ts).
//
// Web-only on top:
// - A Norwegian unit number (bruksenhetsnummer: H, U, K or L for the kind of
//   floor, then floor and door, "H0104") counts as a number too.
// - In a Sub-metering project (`housing`, which useGroupName in lib/group.ts
//   passes for those projects only) a group is an apartment and its category
//   its building, so every apartment shows its building, whatever its name
//   ("Leilighet 3B · Hage 1"), unless the name already holds it; and a
//   building named only by a number says so: "Building 12", alone and after
//   an apartment ("5 · Building 12").
// Free of imports so `node --test` runs it (tests/groupName.test.ts).
const UNIT_NUMBER = /^[HUKL]\d{4}$/i;
const onlyNumber = (s: string): boolean => s !== '' && (!/\p{L}/u.test(s) || UNIT_NUMBER.test(s));

export function groupDisplayName(
  group: { type?: 'g' | 'c'; name: string; category_name?: string | null },
  housing?: { building: (name: string) => string },
): string {
  const name = group.name.trim();
  if (group.type === 'c') return housing && onlyNumber(name) ? housing.building(name) : group.name;
  const own = group.category_name?.trim();
  if (!own) return group.name;
  const category = housing && onlyNumber(own) ? housing.building(own) : own;
  if (!name) return category;
  if (housing) return name.toLowerCase().includes(own.toLowerCase()) ? group.name : `${name} · ${category}`;
  return onlyNumber(name) ? `${name} · ${category}` : group.name;
}
